// Login.style.ts

import { CSSProperties } from "react";

export interface Styles {
  bg: CSSProperties;
  bottomText: CSSProperties;
  storeWrap: CSSProperties;
  storeImageWrap: CSSProperties;
  storeImage: CSSProperties;
  searchRow :CSSProperties;
  storeNameWrap: CSSProperties;
  storeName: CSSProperties;
  storeHeader: CSSProperties;
  timeWrap: CSSProperties;
  time: CSSProperties;
  location: CSSProperties;
  ratingWrap: CSSProperties;
  headerLogo: CSSProperties;
  headerLogoBrand: CSSProperties;
  searchBox: CSSProperties;
  breadcrumb: CSSProperties;
  breadcrumbCurrent: CSSProperties;
}

const baseStyles: Styles = {
  searchRow: {
    marginBottom: 70,
    maxWidth: 1142,
    marginLeft: "auto",
    marginRight: "auto",
  },
  // Plain white: the banner fallback already uses the brand artwork
  bg: {
    backgroundColor: "var(--white-color)",
    paddingTop: 40,
    paddingBottom: 40,
    marginBottom: 20,
  },
  bottomText: {
    fontFamily: "var(--primary-font-semibold)",
    fontSize: 12,
    lineHeight: 1.2,
    color: "var(--text-color)",
    marginTop: 10,
    position: "absolute",
    left: "auto",
    right: "auto",
    bottom: 10,
  },
  storeWrap: {},
  storeImageWrap: {width:70,height:70},
  storeImage: {objectFit:"contain",width:"100%",height:"100%",borderRadius:15},
  storeNameWrap: {},
  storeName: {
    marginLeft:20,
    fontFamily:'var(--primary-font-semibold)',
    fontSize:36,
    color:'var(--text-color)',
    marginBottom:0
  },
  storeHeader: {
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    marginBottom:15,
    marginTop:30
  },
  timeWrap: {
    display:"flex",
    backgroundColor:"#D9D9D9",
    borderRadius:3,
    alignItems:"center",
    justifyContent:"center",
    width:150,
    textAlign:"center",
    padding:10
  },
  time: {
    marginBottom:0,
    fontFamily:'var(--primary-font-medium)',
    fontSize:14,
    color:'var(--black-color)'
  },
  ratingWrap: {
    display:"flex",
    alignItems:"center",
    marginTop:0,
    marginBottom:0,
    float:"left",
    cursor:"pointer",
    marginLeft:20,
    // justifyContent:"center"
  },
  location: {
    fontFamily:'var(--primary-font-medium)',
    fontSize:24,
    color:'#AFABAB',
    marginBottom:15
  },
  // Store logo tile: fixed size; brand green behind the icon when there's no logo
  headerLogo: { width: 72, height: 72 },
  headerLogoBrand: { width: 72, height: 72, backgroundColor: "#0F4A2F" },
  breadcrumb: { fontSize: 12, color: "#4b5563" },
  breadcrumbCurrent: {
    fontFamily: "var(--primary-font-semibold)",
    color: "#1A1B22",
  },
  // Product search, on the right of the products section's title row
  searchBox: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    background: "rgba(255, 255, 255, 0.9)",
    borderRadius: "20px",
    padding: "5px",
    boxShadow: "0 8px 25px rgba(0, 0, 0, 0.1)",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    minWidth: 250,
  },
};

const mobileStyles: Partial<Styles> = {
  storeName: {
    marginLeft:20,
    fontFamily:'var(--primary-font-semibold)',
    fontSize:20,
    color:'var(--text-color)'
  },
  storeImageWrap: {width:40,height:40},
  headerLogo: { width: 56, height: 56 },
  headerLogoBrand: { ...baseStyles.headerLogoBrand, width: 56, height: 56 },
  searchBox: { ...baseStyles.searchBox, minWidth: 200 },
};
export const getStyles = (isMobile: boolean): Styles => {
  if (isMobile) {
    return {
      ...baseStyles,
      ...mobileStyles,
    };
  }
  return baseStyles;
};